import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  addDeliveryPartnerApi,
  deleteDeliveryPartnerApi,
  getDeliveryPartnersApi,
  updateDeliveryPartnerApi,
} from "../../../../services/manage-order/setting/deliveryPartnerService";
import { toast } from "react-toastify";

export const getOrderDeliveryPartnerSettings = createAsyncThunk(
  "orderSettings/getOrderDeliveryPartnerSettingData",
  async (_, { dispatch }) => {
    const response = await getDeliveryPartnersApi();
    return response.response;
  }
);
export const storeDeliveryPartner = createAsyncThunk(
  "orderSettings/storeDeliveryPartnerData",
  async (data, { dispatch }) => {
    const response = await addDeliveryPartnerApi(data);
    const res = response.response;
    dispatch(getOrderDeliveryPartnerSettings());
    toast.success("Added Delivery Partner successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return res;
  }
);

export const updateDeliveryPartner = createAsyncThunk(
  "orderSettings/updateDeliveryPartnerData",
  async (deliveryPartner, { dispatch, getStatus }) => {
    try {
      const response = await updateDeliveryPartnerApi(
        deliveryPartner,
        deliveryPartner.id
      );
      const data = await response.response;
      dispatch(getOrderDeliveryPartnerSettings());
      toast.success("Delivery Partner updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return data;
    } catch (e) {
      console.log("Error updating: " + e.message);
      return Promise.reject(e);
    }
  }
);

export const deleteDeliveryPartner = createAsyncThunk(
  "orderSettings/deleteDeliveryPartnerData",
  async (id, { dispatch }) => {
    const response = await deleteDeliveryPartnerApi(id);
    const res = response.response;
    dispatch(getOrderDeliveryPartnerSettings());
    toast.success("Delivery Partner Method successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return res;
  }
);

const deliveryPartnerSettingAdapter = createEntityAdapter();

const deliveryPartnerSettingSlice = createSlice({
  name: "deliveryPartnerSetting",
  initialState: deliveryPartnerSettingAdapter.getInitialState({
    addDialog: {
      component: "deliveryPartnerSetting",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "deliveryPartnerSetting",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getOrderDeliveryPartnerSettings.fulfilled]:
      deliveryPartnerSettingAdapter.setAll,
  },
});
export const { openNewDialog, openEditDialog, closeEditDialog } =
  deliveryPartnerSettingSlice.actions;
export default deliveryPartnerSettingSlice.reducer;
